import React, { useState, useEffect, useRef } from 'react';
import { Modal, Box, Button, Card, CardContent, CardActions, Grid, Typography} from '@mui/material';
import Swal from 'sweetalert2';
import ReactQuill from 'react-quill-new';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import strings from "../../Globalization/index";
import connectionService from "../../services/Connection";
import util from '../../util/index';
import { useBreadcrumbs } from '../../contexts/Breadcrumbs';
import 'react-quill-new/dist/quill.snow.css';
import { dataStore } from '../../Store';
import consts from '../../consts';

const endoRoles = ['physician admin', 'huluadmin'];
const baseUrl = `${consts.hostURL.URL}`;
// validating the license type
const isLicenseType = ({ licenseName = '', licenseAppName}) => {
	return licenseAppName.includes(licenseName)
}
const getRoll = (roleName) => {
	return consts.requiredRoleForHelp.includes(roleName.toLowerCase());
}
const notAllowedRole = (roleName) => {
	return endoRoles.includes(roleName.toLowerCase())
}
const HelpForm = (props) => {
	const location = useLocation();
	const { auth = {} } = dataStore.getState() || {};
	const tags = auth.tags || {};
	const licenseAppName = tags.LicenseAppName || [];
	const roleName = tags.RoleName || '';
	const { navigate, locationLabel, isOpen, onClose } = props;
	const [fileName, setFileName] = useState(props.filename);
	const [responseData, setResponseData] = useState({});
	const [content, setContent] = useState("");
	const [, setBreadcrumbs] = useBreadcrumbs([{ text: 'TrainingVideos' }]);
	const isCatViewerLicensed = isLicenseType({ licenseName: 'catviewer', licenseAppName });
	const isCatEndLicensed = isLicenseType({ licenseName: 'catendo', licenseAppName });
	const isEndoManualShow = getRoll(roleName);
	const isAllowedtoShow = notAllowedRole(roleName);
	let disableHelp = !tags.IsAdmin;
	let scope = props.scope ? props.scope : null;
	let helpFileName = fileName || '';
	const preferredLang = consts.languageMapper[util.localData.PTXPreferredLang];
	const loadHelpData = (action, fileName, showHelp, fileData) => {
		if (showHelp) {
			let data = { action: action, Help: 'Help' };
			data.helpContext = fileName;
			data.content = action === "load" ? '' : fileData;

			let formData = new FormData();
			formData.append('action', action);
			formData.append('Help', 'Help');
			formData.append('helpContext', fileName);
			formData.append('preferredLang', preferredLang);
			formData.append('content', action === "load" ? '' : fileData);
			fetch(connectionService.Help, {
				method: 'POST',
				body: formData,
				credentials: 'include'
			})
				.then((response) => response.text())
				.then((responseText) => {
					let responseData = {};
					if (responseText) {
						responseData.data = JSON.parse(responseText);
						if (responseData.data.action === "save") {
							if (responseData.data.Success) {
								Swal.fire({ titleText: strings.Success, text: strings.SavedData, icon: 'success', confirmButtonText: strings.Ok, allowOutsideClick: false });
							}
							else {
								Swal.fire({ titleText: strings.ErrorTitle, text: strings.ErrorUpdate, icon: 'error', confirmButtonText: strings.Ok, allowOutsideClick: false });
							}
						}
					}
					responseData.fileName = fileName;
					setResponseData(responseData);
				})
		}
	}

	useEffect(() => {
    const isBlockedRole = consts.regex.AdminOrViewer.test(roleName);
    if (!isBlockedRole && location.pathname !== '/setup') {
        loadHelpData('load', fileName, true, content);
    }
	}, []);

	useEffect(() => {
		if (!content && responseData.data) {
			const helpDataValue = responseData.data;
			setContent(helpDataValue.IsFileData ? helpDataValue.Content : strings[helpDataValue.Content] || "");
		}
	}, [responseData, content, strings]);

	const onHelpTextChange = (updatedContent) => {
		setContent(updatedContent);
	}

	const saveHelpData = (action, showHide) => {
		loadHelpData(action, fileName, showHide, content);
	}

	const onRequestClose = () => { }

	const downloadManual = ({ isEndo = false }) => {
		let operatorManualPath = isEndo ? responseData.data.endo : responseData.data.operator;
		window.open(`${baseUrl}${operatorManualPath}`, "_blank");
	}

	const sterisInService = () => {
		let ServiceInPath = util.checkConfigData('ServiceInPathAccess') || "https://www.steris.com/inservice";
		window.open(ServiceInPath, "_blank");
	}

	const supportManual = () => {
		let supportManualFile = responseData.data.support;

		window.open(`${baseUrl}${supportManualFile}`, "_blank");
	}

	const trainingVideos = (view) => {
		navigate(`${view.startsWith('/') ? '' : '/'}${view}`);
	}

	let contentData = content;
	const modalStyle = {
		overlay: {
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			zIndex: 99999999,
			overflow: 'hidden',
			perspective: 1300,
			backgroundColor: 'rgba(0, 0, 0, 0.3)',
		},
		content: {
			position: 'relative',
			margin: '6% auto',
			width: '68%',
			border: '1px solid rgba(0, 0, 0, .2)',
			background: '#fff',
			overflow: 'auto',
			borderRadius: '4px',
			outline: 'none',
			boxShadow: '0 5px 10px rgba(0, 0, 0, .3)',
		},
	};

	return (
		<Modal
			open={isOpen}
			onClose={onClose}
			aria-labelledby="help-form-modal"
			aria-describedby="help-form-description"
		>
			<Box sx={modalStyle.content}>
				<Card className="wrapper ibox float-e-margins" sx={{
					marginBottom: 'auto',
					width: '100%',
				}}
				>
					<CardContent>
						<Grid container alignItems="center" justifyContent="space-between" style={{ margin: "0.4rem 0.8rem" }}>
							<Grid size={{xs: 12, sm: 6, md: 4}} className="default-color">
								<Typography component="div" className="breadcrumb">
									<Typography component="span">
										{locationLabel || helpFileName.substr(helpFileName.indexOf('/ ') + 1)
											.trim()
											.charAt(0)
											.toUpperCase() +
											helpFileName.substr(helpFileName.indexOf('/ ') + 1)
												.trim()
												.slice(1)
												.toLowerCase()}
									</Typography>
									<Typography component="span"> / </Typography>
									<Typography component="span" className="active">
										{strings.HelpForm}
									</Typography>
								</Typography>
							</Grid>
							<CardActions>
								<Button variant="contained" color="primary" size="small" title={strings.Support} onClick={supportManual} sx={{ mr: 2 }}>
									<i className="fa fa-file-alt"></i> &nbsp;{strings.Support}
								</Button>
							</CardActions>
						</Grid>

						<div className="well row wrapper ibox-content">
							<div>
								<div className="ibox-body">
									<label style={{ fontWeight: "800", marginBottom: 3 }} className="input">{strings.EditAdd}</label>
									{
										<ReactQuill
											onChange={onHelpTextChange}
											placeholder='Please see the Viewer Operator Manual or Endo Operator Manual for specific help in CAT Viewer or CAT Endo Management.'
											value={contentData}
											readOnly={disableHelp}
											style={{ height: '8rem', marginBottom: '3rem' }} />
									}
								</div>
								<Grid container sx={{
									justifyContent: "space-between",
									alignItems: "center",
									marginTop: '0.5rem',
									display: "inline-flex",
									flexWrap: 'wrap'
								}} width={'100%'}>
									<Grid item >
										<Grid container spacing={2} sx={{ marginBottom: '0.5rem' }}>
											{tags.IsAdmin &&
													<Button variant="contained" color="primary" size="small" title={strings.Save} onClick={() => saveHelpData("save", true)} startIcon={<SaveIcon fontSize="inherit" />}>
													{strings.Save}
												</Button>
											}
											<Grid size="auto">
												<Button variant="contained" color="warning" size="small" onClick={onClose} startIcon={<CloseIcon fontSize="inherit"/>}>{strings.Close}</Button>
											</Grid>
										</Grid>
									</Grid>
									<Grid item sx={{ marginBottom: '7px', align: 'right' }} >
										<Grid container spacing={2}>
											{(isCatViewerLicensed || isCatEndLicensed ) && <Grid size="auto">
												<Button variant="contained" color="primary" size="small" title={strings.TrainingVideos}  onClick={() => trainingVideos('VideoList', scope)}>
													<i className="fa fa-film"></i> &nbsp;{strings.TrainingVideos}
												</Button>
											</Grid>
											}
											<Grid size="auto">
												<Button variant="contained" color="primary" size="small" title={strings.SterisInservice} onClick={sterisInService}>
													<i className="fa fa-file-alt"></i> &nbsp;{strings.SterisInservice}
												</Button>
											</Grid>

											{isCatViewerLicensed && !isAllowedtoShow && <Grid size="auto">
												<Button variant="contained" color="primary" size="small" title={strings.OperatorManual} onClick={downloadManual}>
													<i className="fa fa-file-alt"></i> &nbsp;{strings.OperatorManual}
												</Button>
											</Grid>
											}
											{isCatEndLicensed && isEndoManualShow && <Grid size="auto">
												<Button variant="contained" color="primary" size="small" title={strings.endoOperatorManual} onClick={() => downloadManual({ isEndo: true })} >
													<i className="fa fa-file-alt"></i> &nbsp;{strings.endoOperatorManual}
												</Button>
											</Grid>
											}
										</Grid>
									</Grid>
								</Grid>
							</div>
						</div>
					</CardContent>
				</Card>
			</Box>
		</Modal>
	)
};

export default HelpForm;